import { cn } from '../../util';

export function CardDescription({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('text-muted-foreground text-sm', className)} {...props} />;
}
